/**
 * Naively determines if a string is a pathname.
 *
 * @param {string} string The string.
 * @returns {*}
 */
export const isLocationPathname = string => {
  return string?.includes('/app');
};
